exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".xTauxHpipNtCUb6beWVmJw\\=\\={height:100%;width:100%;position:absolute}", ""]);
// Exports
exports.locals = {
	"layer": "xTauxHpipNtCUb6beWVmJw=="
};